const BASE_URL = process.env.REACT_APP_API_URL || "/api/healthcare";

function getToken() {
  return localStorage.getItem("ts360_token");
}

async function request(method, path, body, isFormData = false) {
  const headers = {};
  const token = getToken();

  if (token) headers.Authorization = `Bearer ${token}`;
  if (!isFormData && body !== undefined) headers["Content-Type"] = "application/json";

  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers,
    body: isFormData ? body : body !== undefined ? JSON.stringify(body) : undefined,
  });

  const contentType = res.headers.get("content-type") || "";
  const isDownload = contentType.includes("application/vnd") ||
    contentType.includes("text/csv") ||
    contentType.includes("application/xml");

  if (isDownload) {
    if (!res.ok) throw new Error(`Download failed (${res.status})`);
    return res.blob();
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 401) {
      localStorage.removeItem("ts360_token");
      localStorage.removeItem("ts360_user");
      window.location.href = "/";
    }
    const detail = data.details || data.message;
    throw new Error(detail ? `${data.error || `Request failed (${res.status})`}: ${detail}` : data.error || `Request failed (${res.status})`);
  }

  return data;
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const api = {
  get: (path) => request("GET", path),
  post: (path, body) => request("POST", path, body),
  patch: (path, body) => request("PATCH", path, body),
  put: (path, body) => request("PUT", path, body),
  delete: (path) => request("DELETE", path),
  upload: (path, formData) => request("POST", path, formData, true),
  download: async (path, body, filename) => {
    const blob = body === null || body === undefined
      ? await request("GET", path)
      : await request("POST", path, body);
    downloadBlob(blob, filename);
  },
};
